import { useEffect, useState, useCallback } from 'react'
import axios from 'axios'
import Draw from 'ol/interaction/Draw'
import { useSelector, useDispatch } from 'react-redux'
import SourceWMTS from 'ol/source/WMTS'
import TileWMS from 'ol/source/TileWMS'
import OLTileLayer from 'ol/layer/Tile'

import WMTSCapabilities from 'ol/format/WMTSCapabilities'
import { optionsFromCapabilities } from 'ol/source/WMTS'

import {
  GEOSERVER_WMTS_LAYER,
  GEOSERVER_WMS_LAYER,
  GEOSERVER_URL,
} from '../../config/index'
import { getPointAction } from '../../redux/actions/points.actions'
import {
  setTileLoaded,
  setTileLoading,
  setChartContainerOpen
} from '../../redux/actions/map.actions'
import { getDeformationRateIntervalString } from "../../utils/map.utils"
// WMS layer for proxy onclick events in WMTS layers.
const WMTSLayer = ({ zIndex = 0, capabilitiesUrl, wmsUrl }) => {
  const dispatch = useDispatch()
  const olMap = useSelector((state) => state.mapStates.olMap)
  const type = useSelector((state) => state.mapStates.type)
  const deformationRateIntervalValue = useSelector((state) => state.mapStates.deformationRateIntervalValue)
  const deformationIntervalString = getDeformationRateIntervalString(Number(deformationRateIntervalValue))
  const [capabilities, setCapabilities] = useState(null)

  const wmsSource = (wmsUrl, type, deformationRateIntervalValue) => {
    return new TileWMS({
      url: wmsUrl,
      params: {
        FORMAT: "'image/png'",
        VERSION: '1.1.1',
        tiled: true,
        STYLES: '',
        viewparams: `type:${type}${deformationRateIntervalValue > 0 ? `;${deformationIntervalString}` : deformationIntervalString}`,
        EPSG: 4326,
        LAYERS: GEOSERVER_WMS_LAYER,
      },
    })
  }

  useEffect(() => {
    axios.get(capabilitiesUrl).then((response) => {
      const parser = new WMTSCapabilities()
      setCapabilities(
        optionsFromCapabilities(parser.read(response.data), {
          layer: GEOSERVER_WMTS_LAYER,
          matrixSet: 'EPSG:4326',
          crossOrigin: 'anonymous',
        }),
      )
    })
  }, [capabilitiesUrl])

  const onClick = useCallback(
    (evt) => {
      const isDrawActive = evt.map.interactions.array_.some((interaction) => {
        return interaction instanceof Draw
      })

      if (isDrawActive) {
        return
      }

      const viewResolution = olMap.getView().getResolution()

      const url = wmsSource(wmsUrl, type, deformationRateIntervalValue).getFeatureInfoUrl(
        evt.coordinate,
        viewResolution,
        'EPSG:4326',
        {
          FEATURE_COUNT: 1, INFO_FORMAT: 'application/json', viewparams: `type:${type}${deformationRateIntervalValue > 0 ? `;${deformationIntervalString}` : deformationIntervalString}`,

        },
      )
      dispatch(setChartContainerOpen(true))
      if (url) {
        dispatch(getPointAction(url))
      }
    },
    // eslint-disable-next-line 
    [type, dispatch, wmsUrl, deformationRateIntervalValue, deformationIntervalString, olMap],
  );

  useEffect(() => {
    if (!capabilities) return null
    // TODO: find a cleaner solution for this. The GetCapabilities returns
    // worng url, I mean the good ip without port number.
    capabilities.urls = [`${GEOSERVER_URL}/gwc/service/wmts?`]
    capabilities.dimensions = { VIEWPARAMS: `type:${type}${deformationRateIntervalValue > 0 ? `;${deformationIntervalString}` : deformationIntervalString}` }
    const wmtsSource = new SourceWMTS({ ...capabilities, wrapX: true, transition: 0 })
    const layer = new OLTileLayer({
      source: wmtsSource,
      zIndex: zIndex
    })


    olMap.addLayer(layer)
    layer.setZIndex(zIndex)


    layer.getSource().on('tileloadstart', function (e) {
      dispatch(setTileLoading())
    })
    layer.getSource().on('tileloadend', function (e) {
      dispatch(setTileLoaded())
    })

    return () => {
      if (olMap) {
        olMap.removeLayer(layer)
      }
    }
  }, [dispatch, capabilities, zIndex, olMap, type, deformationRateIntervalValue,deformationIntervalString])


  useEffect(() => {
    if (!olMap) return null
    if (olMap.listeners_.singleclick && olMap.listeners_.singleclick.length > 0) {
      olMap.listeners_.singleclick.forEach(element => {
        olMap.un('singleclick', element);
      });
      olMap.on('singleclick', onClick)
    }
  }, [type, olMap, onClick])

  useEffect(() => {
    if (!olMap) return null
    olMap.on('singleclick', onClick)
  }, [olMap, onClick])
  return null
}

export default WMTSLayer
